import { createAsyncAction } from 'typesafe-actions';

import { ResourceLite } from '../resources/createResource';
import { EntityBase } from '../resources/types';

import sagaApi, { Meta, PayloadApiFailure, PayloadApiRequest, PayloadApiSuccess } from './sagaApi';

export interface FetchPagePayload<E extends EntityBase> extends PayloadApiRequest<E> {
  resource: ResourceLite<E>;
  method?: 'get';
  meta?: Meta<E> & {
    resultKey?: string;
    takeLatest?: boolean;
  };
  params: {
    page?: number;
    limit: number;
    [param: string]: any;
  };
}

const fetchPage = createAsyncAction(
  '@lib/fetchPage/REQUEST',
  '@lib/fetchPage/SUCCESS',
  '@lib/fetchPage/FAILURE',
  '@lib/fetchPage/CANCEL',
)<FetchPagePayload<any>, PayloadApiSuccess<any>, PayloadApiFailure, any>();

// saga
export function* sagaFetchPage(action: ReturnType<typeof fetchPage.request>) {
  const {
    payload: { resource, meta, ...config },
  } = action;

  // @ts-ignore
  return yield sagaApi({
    action: fetchPage,
    resource,
    url: resource.fetchPageUrl,
    meta: {
      schema: resource.fetchPageSchema,
      ...meta,
    },
    ...config,
  });
}

export default fetchPage;
